import "./globalCapabilityOverview.css";
import gcAboutImage from "../../../assets/services/gc-about.webp";


const GlobalCapabilityOverview = () => {
  return (
    <section className="gc-overview" id="gc-overview">
      <div className="gc-overview__container">
        <div className="gc-overview__heading">
          <span className="gc-overview__eyebrow">
            <span className="gc-overview__eyebrow-dot" />
            OUR CAPABILITIES
          </span>

          <h2 className="gc-overview__title">
            Capability That Grows
            <br />
            <span>with Your Business</span>
          </h2>
        </div>
        <div className="gc-overview__panel">
          <div className="gc-overview__media">
            <img
              src={gcAboutImage}
              alt="Professionals collaborating in a modern workspace"
              className="gc-overview__image"
              loading="lazy"
            />

            <div
              className="gc-overview__image-overlay"
              aria-hidden="true"
            />

            <span
              className="gc-overview__image-label"
              aria-hidden="true"
            >
              PEOPLE. PROCESS. PROGRESS.
            </span>
          </div>

          <div className="gc-overview__content">
            <span
              className="gc-overview__content-line"
              aria-hidden="true"
            />

            <p className="gc-overview__description">
              From adding skilled professionals to supporting knowledge-driven
              work and operational processes, our service models are designed
              to help businesses address changing requirements. Work with
              Qualitas Global to identify the right approach for your team,
              workflows, and growth plans.
            </p>

            <div
              className="gc-overview__content-mark"
              aria-hidden="true"
            >
              QG<span>.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalCapabilityOverview;